import { ConfigProvider as GenesysConfigProvider } from "@commonlibs";
import { ReactNode } from "react";
import { StyleSheetManager } from "styled-components";
import useTranslate from "ui/locale/hooks/useTranslate";
import config from "./config";
import { GlobalStyles } from "./theme/GlobalStyles/GlobalStyles";
import useLocale from "ui/locale/hooks/useLocale";
import { IAuthBootstrapper } from "commonlibs/shared-services/auth/domain/IAuthBootstraper";
import { CognitoAuthBootstrapper } from "commonlibs/shared-services/auth/cognito/CognitoAuthBootstrapper";
import { config as appConfig } from "common/config";

export interface ConfigProviderProps {
    children?: ReactNode;
}

const ConfigProvider = ({ children }: ConfigProviderProps): JSX.Element => {
    const translate = useTranslate("error");
    const locale = useLocale();
    const authBootstrapper: IAuthBootstrapper = new CognitoAuthBootstrapper();

    authBootstrapper.initialize(appConfig.cognito.poolId, appConfig.cognito.appClientId);
    
    return (
        <GenesysConfigProvider config={{ ...config, translate, locale }}>
            <StyleSheetManager target={document.head}>
                <GlobalStyles />
            </StyleSheetManager>
            {children}
        </GenesysConfigProvider>
    );
};

export default ConfigProvider;
